import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import { ViaCepService } from '../../../core/services/address/via-cep/via-cep.service'
import { EmployeeStatusService } from '../../../core/services/employee/employee-status/employee-status.service'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import { EmployeeRoleService } from '../../../core/services/employee/employee-role/employee-role.service'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { emailValidator } from '../../../shared/utils/email_validator'
import moment from 'moment/moment'
import { cpfValidator } from '../../../shared/utils/cpf_validator'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import { DriverUploadCreateComponent } from '../driver-upload-create/driver-upload-create.component'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { DriverService } from '../../../core/services/driver/driver/driver.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { CreateDriverModel } from '../../../core/models/driver.model'
import { ContactClientEditComponent } from '../../contact/contact-client-edit/contact-client-edit.component'
import { DriverUploadEditComponent } from '../driver-upload-edit/driver-upload-edit.component'

@Component({
  selector: 'driver-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    MatOption,
    MatSelect,
    MatDividerModule,
    NgxMaskDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSlideToggle,
    DriverUploadCreateComponent,
    ContactClientEditComponent,
    DriverUploadEditComponent,
  ],
  templateUrl: './driver-edit.component.html',
  styleUrl: './driver-edit.component.scss',
  providers: [
    ViaCepService,
    EmployeeStatusService,
    DriverService,
    EmployeeRoleService,
    AddressTypeService,
  ],
  standalone: true,
})
export class DriverEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private viaCepService: ViaCepService,
    private employeeStatusService: EmployeeStatusService,
    private driverService: DriverService,
    private addressTypeService: AddressTypeService,
    private driverTypeService: DriverTypeService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<DriverEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth()
    const currentDay = today.getDate()
    this.maxDate = new Date(currentYear - 18, currentMonth, currentDay)
    this.minDate = today
  }

  item: any = {}

  @Output() responseEdit = new EventEmitter()
  @ViewChild('birth') datepickerBirth: MatDatepicker<any> | undefined
  @ViewChild('hiring') datepickerHiring: MatDatepicker<any> | undefined
  @ViewChild('validity') datepickerValidity: MatDatepicker<any> | undefined

  formEmployee: FormGroup = new FormGroup({})
  maxDate!: Date
  minDate!: Date

  loading: boolean = false

  supplierSelected: any = {}
  listAddressType: any[] = []
  listStatusEmployee: any[] = []
  listTypeDriver: any[] = []
  listCategory: any[] = [
    { id: 'A', description: 'A' },
    { id: 'B', description: 'B' },
    { id: 'C', description: 'C' },
    { id: 'D', description: 'D' },
    { id: 'E', description: 'E' },
  ]

  contactList: any[] = []
  fileList: any[] = []
  // public TipoDocId: number = 0
  // public Descricao: string = ''
  // public Arquivo: File | null = null

  ngOnInit(): void {
    this.getAddressType()
    this.getDriverType()
    this.getStatusEmployee()
    this.createForm()
    this.fillForm(this.item)
  }

  close() {
    this.dialogRef.close()
  }

  getAddressType() {
    this.addressTypeService.listAddressType().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listAddressType = list
      },
      error: (err: any) => { },
      complete: () => { },
    })
  }

  getDriverType() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listTypeDriver = list
      },
      error: (err: any) => { },
      complete: () => { },
    })
  }

  getStatusEmployee() {
    this.employeeStatusService.listEmployeeStatus().subscribe({
      next: (response: any) => {
        let list = []
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          list.push({
            id: element.id,
            description: element.descricao,
          })
        }
        this.listStatusEmployee = list
      },
      error: (err: any) => { },
      complete: () => { },
    })
  }

  fillForm(item: any) {
    console.log(item)
    if (item.isAutonomo === 'S') {
      this.formEmployee.get('supplier')!.setValue(item.nome)
    } else {
      this.formEmployee.get('supplier')!.setValue(item.nomeFantasia)
    }
    this.formEmployee.get('name')!.setValue(item.nome)
    this.formEmployee.get('cpf')!.setValue(item.cpf)
    this.formEmployee.get('email')!.setValue(item.email)
    this.formEmployee.get('registration')!.setValue(item.matricula)
    this.formEmployee
      .get('birth')
      ?.setValue(moment(item.dataNascimento, 'DD/MM/YYYY').toDate())
    this.formEmployee
      .get('hiring')
      ?.setValue(moment(item.dataContatacao, 'DD/MM/YYYY').toDate())
    this.formEmployee.get('statusEmployee')!.setValue(item.statusId)
    this.formEmployee.get('typeDriver')!.setValue(item.tipoMotoristaId)
    this.formEmployee.get('docRegistration')!.setValue(item.numeroRegistro)
    this.formEmployee.get('docCategory')!.setValue(item.categoria)
    this.formEmployee
      .get('docValidity')
      ?.setValue(moment(item.validade, 'DD/MM/YYYY').toDate())
    this.formEmployee
      .get('isEmployee')!
      .setValue(item.isFuncionario.toLowerCase() == 's' ? true : false)

    this.formEmployee
      .get('isSelfEmployed')!
      .setValue(item.isAutonomo.toLowerCase() == 's' ? true : false)


    this.formEmployee.get('addressType')!.setValue(item.tipoEnderecoId)
    this.formEmployee.get('postalCode')!.setValue(item.cep)
    this.formEmployee.get('street')!.setValue(item.logradouro)
    this.formEmployee.get('number')!.setValue(item.numero)
    this.formEmployee.get('complement')!.setValue(item.complemento)
    this.formEmployee.get('neighborhood')!.setValue(item.bairro)
    this.formEmployee.get('state')!.setValue(item.estado)
    this.formEmployee.get('city')!.setValue(item.cidade)
    this.formEmployee.get('country')!.setValue(item.pais)
  }

  createModel() {
    return {
      motoristaEditObj: {
        id: this.item.id,
        tipoMotoristaId: this.formEmployee.get('typeDriver')?.value,
        funcionarioId: this.item.funcionarioId,
        numeroRegistro: this.formEmployee.get('docRegistration')?.value,
        categoria: this.formEmployee.get('docCategory')?.value,
        validade: moment(this.formEmployee.get('docValidity')?.value).format(
          'DD/MM/YYYY',
        ),
        pessoaId: this.item.pessoaId,
        nome: this.formEmployee.get('name')?.value,
        cpf: this.formEmployee.get('cpf')?.value,
        email: this.formEmployee.get('email')?.value,
        matricula: this.formEmployee.get('registration')?.value,
        dataNascimento: moment(this.formEmployee.get('birth')?.value).format(
          'DD/MM/YYYY',
        ),
        dataContratacao: moment(this.formEmployee.get('hiring')?.value).format(
          'DD/MM/YYYY',
        ),
        statusId: this.formEmployee.get('statusEmployee')?.value,

        // isFuncionario: this.formEmployee.get('isEmployee')?.value ? 'S' : 'N',
        isFuncionario: 'S',

        // model.FornecedorId = 0
        fornecedorId: null,
        isFornecedor: 'N',
        cnpj: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        nomeFantasia: '',
        razaoSocial: '',
        fornecedorExiste: 'N',
      },
      motoristaEnderecoEditObj: {
        id: this.item.enderecoId,
        tipoEnderecoId: this.formEmployee.get('addressType')?.value,
        cep: this.formEmployee.get('postalCode')?.value,
        logradouro: this.formEmployee.get('street')?.value,
        numero: this.formEmployee.get('number')?.value,
        complemento: this.formEmployee.get('complement')?.value,
        bairro: this.formEmployee.get('neighborhood')?.value,
        estado: this.formEmployee.get('state')?.value,
        cidade: this.formEmployee.get('city')?.value,
        pais: this.formEmployee.get('country')?.value,
        latitude: '',
        longitude: '',
        ativo: 'S',
      },
    }
  }

  createForm(): void {
    this.formEmployee = this.formBuilder.group({
      // Employee fields
      name: ['', [Validators.required, Validators.minLength(3)]],
      cpf: ['', [Validators.required, cpfValidator()]],
      email: ['', [Validators.required, emailValidator()]],
      registration: [''],
      birth: ['', [Validators.required]],
      hiring: [''],
      statusEmployee: ['', [Validators.required]],
      typeDriver: ['', [Validators.required]],
      docRegistration: ['', [Validators.required]],
      docCategory: ['', [Validators.required]],
      docValidity: ['', Validators.required],
      isEmployee: [''],
      isSelfEmployed: [''],
      supplier: [''],
      // Adress fields
      addressType: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      street: ['', [Validators.required]],
      number: ['', [Validators.required]],
      complement: [''],
      neighborhood: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      country: ['', [Validators.required]],
    })
    this.formEmployee.get('isEmployee')?.disable()
    this.formEmployee.get('isSelfEmployed')?.disable()
    this.formEmployee.get('supplier')?.disable()
  }

  fillFormViaCep(element: any) {
    if (element.erro) {
      this.formEmployee.get('street')?.setValue('')
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue('')
      this.formEmployee.get('neighborhood')?.setValue('')
      this.formEmployee.get('city')?.setValue('')
      this.formEmployee.get('state')?.setValue('')
      this.formEmployee.get('country')?.setValue('')
    } else {
      this.formEmployee.get('street')?.setValue(element.logradouro)
      this.formEmployee.get('number')?.setValue('')
      this.formEmployee.get('complement')?.setValue(element.complemento)
      this.formEmployee.get('neighborhood')?.setValue(element.bairro)
      this.formEmployee.get('city')?.setValue(element.localidade)
      this.formEmployee.get('state')?.setValue(element.estado)
      this.formEmployee.get('country')?.setValue('Brasil')
    }
  }

  getAddressByPostalCode() {
    let postalCode = this.formEmployee.get('postalCode')?.value
    if (postalCode != '' && postalCode.length >= 8) {
      this.viaCepService.getAdressbyPostalCode(postalCode).subscribe({
        next: (response: any) => {
          this.fillFormViaCep(response)
        },
        error: (err: ResponseRequestModel) => {
          console.error(err)
        },
        complete: () => { },
      })
    }
  }

  getList(list: any[], type: 'contact' | 'file') {
    switch (type) {
      case 'contact':
        this.contactList = list
        break
      case 'file':
        this.fileList = list
        break
    }
  }

  editDriver() {
    this.loading = true
    this.driverService.editDriver(this.createModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.loading = false
        this.snackbar.success(response.message)
        this.responseEdit.emit()
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        // this.formIndividual.reset()
        // this.formFinancial.reset()
      },
    })
  }

  openDatepicker(datePicker: 'hiring' | 'birth' | 'validity') {
    if (this.datepickerBirth && datePicker == 'birth') {
      this.datepickerBirth.open()
    }
    if (this.datepickerHiring && datePicker == 'hiring') {
      this.datepickerHiring.open()
    }
    if (this.datepickerValidity && datePicker == 'validity') {
      this.datepickerValidity.open()
    }
  }

  checkForm() {
    if (
      this.formEmployee.valid
      // this.formEmployee.valid &&
      // this.contactList.length >= 1 &&
      // this.fileList.length >= 1
    ) {
      return true
    } else {
      return false
    }
  }

  checkSupplier() {
    const value = this.formEmployee.get('isEmployee')?.value;
    if (!value) {
      // Funcionário: habilita campo fornecedor
      this.formEmployee.get('supplier')?.enable();
      this.formEmployee.get('isSelfEmployed')?.enable();
    } else {
      // Prestador: desabilita campo fornecedor e limpa valor
      this.formEmployee.get('isSelfEmployed')?.setValue(false);
      this.formEmployee.get('isSelfEmployed')?.disable();
      this.formEmployee.get('supplier')?.disable();
      this.formEmployee.get('supplier')?.setValue('');
      this.supplierSelected = {};
    }
  }

  checkSelfEmployed() {
    const value = this.formEmployee.get('isSelfEmployed')?.value;
    if (!value) {
      // Funcionário: habilita campo fornecedor
      this.formEmployee.get('supplier')?.enable()
    } else {
      // Prestador: desabilita campo fornecedor e limpa valor
      this.formEmployee.get('supplier')?.disable()
      this.formEmployee.get('supplier')?.setValue('')
      this.supplierSelected = {};
    }
  }

}
